import { LANGUAGE_CODES } from "./Language";

export interface Translation {
  key: string;
  language: LANGUAGE_CODES;
  value: string;
}
